import React from 'react';
import { IconBack } from './Icons';
import './BackButton.css';

/**
 * Shared navigation "back" control. One pill — the line-stroke `IconBack` glyph
 * plus a label — used everywhere the app navigates up a level (thread → thread
 * list, a Lobby subview → Today), so every back affordance looks and behaves
 * identically. The label collapses to icon-only on phones to reclaim space.
 */
export default function BackButton({ label = 'Back', title, onClick, className = '' }) {
  return (
    <button
      type="button"
      className={`back-button ${className}`.trim()}
      onClick={onClick}
      title={title || label}
      aria-label={title || label}
    >
      <IconBack size={16} />
      <span className="back-button-label">{label}</span>
    </button>
  );
}
